import { PlayIcon } from "@/components/icons/editor/play-icon";
export default function DummyPromoVideo() {
  return <div className="group z-[20] flex h-full flex-col p-6 pb-20" data-sentry-component="DummyPromoVideo" data-sentry-source-file="dummy-promo-video.tsx">
      <div className="flex flex-1 items-center justify-center">
        <div className="relative">
          <div className="flex h-40 w-40 items-center justify-center rounded-full bg-orange-500/5 opacity-85 transition-all duration-500 group-hover:opacity-100">
            <div className="flex h-32 w-32 items-center justify-center rounded-full bg-orange-500/10">
              <div className="flex h-24 w-24 items-center justify-center rounded-full bg-orange-500/15">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-orange-500/20">
                  <div className="relative flex h-12 w-12 items-center justify-center rounded-full bg-black/60 shadow-[0_0_15px_rgba(249,115,22,0.5)] transition-all duration-500 group-hover:bg-black/80">
                    <PlayIcon className="h-6 w-6 text-orange-200" data-sentry-element="PlayIcon" data-sentry-source-file="dummy-promo-video.tsx" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0 w-full rounded-b-3xl bg-gradient-to-t from-black via-black to-transparent px-6 pb-6 pt-20">
        <div className="mb-2 flex items-center gap-2">
          <h3 className="text-xl font-bold text-white">Promo Videos</h3>
        </div>
        <p className="text-gray-300">
          Create promo videos that stand out and get your idea noticed.
        </p>
      </div>
    </div>;
}